import React, { useRef, useEffect, useState, useCallback } from "react";

import {
  getClassDistributionSummaryActionHandler,
  getClassVisualReportActionHandler,
  getTrainingTypesActionHandler,
  getAssignedClassActionHandler,
  getFilterClassDistributionSummaryActionHandler,
  getFilterClassVisualReportActionHandler,
} from "../../../../store/actions/actionHandlers/reportActionHandler";
import { FormProvider, useForm } from "react-hook-form";
import Input from "../../../../components/Common/ReactForm/Input/Input";
import Button from "../../../../components/Common/Button/Button";
import {
  Chart as ChartJS,
  ArcElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  BarElement,
} from "chart.js";
import moment from "moment";
import Dropdown from "../../../../components/Common/ReactForm/Dropdown/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import classes from "./ClassGraphicalReport.module.scss";
import ReportGraph from "../../ReportGraph/ReportGraph";
import { errorTypes } from "../../../../utils/errorTypes";
import { setErrorAction } from "../../../../store/actions/actionCreators/errorActionCreator";
import { FormattedMessage, injectIntl } from "react-intl";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import InputHookForm from "../../../../components/Common/Input/Input";

const chartColors = [
  "#1f77b4",
  "#ff7f0e",
  "#2ca02c",
  "#d62728",
  "#9467bd",
  "#8c564b",
  "#e377c2",
  "#7f7f7f",
  "#bcbd22",
  "#17becf",
];

export const graphicalReportSchema = yup.object().shape({
  ClassName: yup
    .array(
      yup.object().shape({
        Name: yup.string(),
        Id: yup.number(),
      })
    )
    .min(1, "Select at least One Class to proceed")
    .max(5, "Maximum 5 Classes are allowed"),
  TrainingTypes: yup
    .array(
      yup.object().shape({
        Name: yup.string(),
        TypeId: yup.number(),
      })
    )
    // .min(1, "Select at least One User to proceed")
    .max(15, "Maximum 15 Training Types are allowed"),
});

const ClassGraphicalReport = ({ intl }) => {
  const fileRef = useRef(true);
  const dispatch = useDispatch();
  const reportState = useSelector((state) => state.reportReducer);
  const {
    classDistributionSummary,
    classVisualReport,
    filterClassVisualReport,
    filterClassDistributionSummary,
    trainingTypes,
    assignedClass,
  } = reportState;
  const [searchClicked, setSearchClicked] = useState(false);

  const { SUCCESS, FAIL, WARN } = errorTypes;

  const filterClassMostCreditData = filterClassVisualReport?.MostCredit;
  const filterClassMostPassedData = filterClassVisualReport?.MostPassed;
  const filterClassMostRatedData = filterClassVisualReport?.MostRated;

  const filterClassPublishedData =
    filterClassDistributionSummary?.CompletedLineData;
  const filterClassDraftData =
    filterClassDistributionSummary?.NotYetCompletedLineData;
  const filterClassDistributedData =
    filterClassDistributionSummary?.InProgressLineData;

  let classDoughnutChartColors = ["#2c92de", "#0b931f", "#ffcb00"];
  let filterClassDoughnutChartColors = ["#0b931f", "#2c92de", "#E00000"];

  const [trainingTypesOptions, setTrainingTypesOptions] = useState([]);
  const [assignedClassOptions, setAssignedClassOptions] = useState([]);

  const [selectedTraining, setSelctedTraining] = useState([]);
  const [selectedClass, setSelectedClass] = useState([]);

  const onTrainingSelected = (selected) => {
    setSelctedTraining(selected);
  };

  const onAssignedClassSelected = (selected) => {
    setSelectedClass(selected);
  };

  let selectedClassName = selectedClass?.map((opt) => opt.value);
  let selectedTrainingType = selectedTraining?.map((opt) => opt.value);

  let filterClassTotal =
    filterClassDistributionSummary?.Completed +
    filterClassDistributionSummary?.NotStartedYet +
    filterClassDistributionSummary?.InProgress;
  let filterClassCompletePercent = 0;
  if (filterClassDistributionSummary?.Completed === 0)
    filterClassCompletePercent = filterClassDistributionSummary?.Completed;
  else
    filterClassCompletePercent =
      (filterClassDistributionSummary?.Completed / filterClassTotal) * 100;
  let filterClassCompletePercentage = Math.round(filterClassCompletePercent);

  let filterClassNotStartedYetPercent = null;
  if (filterClassDistributionSummary?.NotStartedYet === 0)
    filterClassNotStartedYetPercent =
      filterClassDistributionSummary?.NotStartedYet;
  else
    filterClassNotStartedYetPercent =
      (filterClassDistributionSummary?.NotStartedYet / filterClassTotal) * 100;
  let filterClassNotStartedYetPercentage = Math.round(
    filterClassNotStartedYetPercent
  );

  let filterClassInProgessPercent = null;
  if (filterClassDistributionSummary?.InProgress === 0)
    filterClassInProgessPercent = filterClassDistributionSummary?.InProgress;
  else
    filterClassInProgessPercent =
      (filterClassDistributionSummary?.InProgress / filterClassTotal) * 100;
  let filterClassInProgressPercentage = Math.round(filterClassInProgessPercent);

  const filterClassCreditBarData = {
    labels: filterClassMostCreditData?.map((el) => el.Name),
    datasets: [
      {
        data: filterClassMostCreditData?.map((el) => el.Value),
        backgroundColor: chartColors,
      },
    ],
  };

  const filterClassPassedBarData = {
    labels: filterClassMostPassedData?.map((el) => el.Name),
    datasets: [
      {
        data: filterClassMostPassedData?.map((el) => el.Value),
        backgroundColor: chartColors,
      },
    ],
  };

  const filterClassRatedBarData = {
    labels: filterClassMostRatedData?.map((el) => el.Name),
    datasets: [
      {
        data: filterClassMostRatedData?.map((el) => el.Value),
        backgroundColor: chartColors,
      },
    ],
  };

  const filterClassDistributionDoughnutData = {
    labels: ["Completed", "In Progress", "Not Started Yet"],
    datasets: [
      {
        data: [
          filterClassCompletePercentage,
          filterClassInProgressPercentage,
          filterClassNotStartedYetPercentage,
        ],
        backgroundColor: filterClassDoughnutChartColors,
      },
    ],
  };

  const filterClassLineData = {
    labels: filterClassPublishedData
      ?.map((el) => moment(el.Date).format("DD-MMM-YY"))
      .reverse(),
    datasets: [
      {
        data: filterClassPublishedData?.map((el) => el.Value).reverse(),
        borderColor: "#2c92de",
        backgroundColor: "#2c92de",
        tension: 0.2,
        borderWidth: 2,
      },
      {
        data: filterClassDraftData?.map((el) => el.Value).reverse(),
        borderColor: "#ffcb00",
        backgroundColor: "#ffcb00",
        tension: 0.2,
        borderWidth: 2,
      },
      {
        data: filterClassDistributedData?.map((el) => el.Value).reverse(),
        borderColor: "#0b931f",
        backgroundColor: "#0b931f",
        tension: 0.2,
        borderWidth: 2,
      },
    ],
  };

  const classMostCreditData = classVisualReport?.MostCredit;
  const classMostPassedData = classVisualReport?.MostPassed;
  const classMostRatedData = classVisualReport?.MostRated;
  const classPublishedData = classDistributionSummary?.CompletedLineData;
  const classDraftData = classDistributionSummary?.NotYetCompletedLineData;
  const classDistributedData = classDistributionSummary?.InProgressLineData;

  let classTotal =
    classDistributionSummary?.Completed +
    classDistributionSummary?.NotStartedYet +
    classDistributionSummary?.InProgress;
  let classCompletePercent = 0;
  if (classDistributionSummary?.Completed === 0)
    classCompletePercent = classDistributionSummary?.Completed;
  else
    classCompletePercent =
      (classDistributionSummary?.Completed / classTotal) * 100;
  let classCompletePercentage = Math.round(classCompletePercent);

  let classNotStartedYetPercent = null;
  if (classDistributionSummary?.NotStartedYet === 0)
    classNotStartedYetPercent = classDistributionSummary?.NotStartedYet;
  else
    classNotStartedYetPercent =
      (classDistributionSummary?.NotStartedYet / classTotal) * 100;
  let classNotStartedYetPercentage = Math.round(classNotStartedYetPercent);

  let classInProgessPercent = null;
  if (classDistributionSummary?.InProgress === 0)
    classInProgessPercent = classDistributionSummary?.InProgress;
  else
    classInProgessPercent =
      (classDistributionSummary?.InProgress / classTotal) * 100;
  let classInProgressPercentage = Math.round(classInProgessPercent);

  const classCreditBarData = {
    labels: classMostCreditData?.map((el) => el.Name),
    datasets: [
      {
        data: classMostCreditData?.map((el) => el.Value),
        backgroundColor: chartColors,
      },
    ],
  };

  const classPassBarData = {
    labels: classMostPassedData?.map((el) => el.Name),
    datasets: [
      {
        data: classMostPassedData?.map((el) => el.Value),
        backgroundColor: chartColors,
      },
    ],
  };

  const classRatedBarData = {
    labels: classMostRatedData?.map((el) => el.Name),
    datasets: [
      {
        data: classMostRatedData?.map((el) => el.Value),
        backgroundColor: chartColors,
      },
    ],
  };

  const classDistributionDoughnutData = {
    labels: ["Published", "Distributed", "Draft"],
    datasets: [
      {
        data: [
          classCompletePercentage,
          classInProgressPercentage,
          classNotStartedYetPercentage,
        ],
        backgroundColor: classDoughnutChartColors,
      },
    ],
  };

  var classDistributionOptions = {
    cutout: "40%",
  };

  const classLineData = {
    labels: classPublishedData
      ?.map((el) => moment(el.Date).format("DD-MMM-YY"))
      .reverse(),
    datasets: [
      {
        data: classPublishedData?.map((el) => el.Value).reverse(),
        borderColor: "#2c92de",
        backgroundColor: "#2c92de",
        tension: 0.2,
        borderWidth: 2,
      },
      {
        data: classDraftData?.map((el) => el.Value).reverse(),
        borderColor: "#ffcb00",
        backgroundColor: "#ffcb00",
        tension: 0.2,
        borderWidth: 2,
      },
      {
        data: classDistributedData?.map((el) => el.Value).reverse(),
        borderColor: "#0b931f",
        backgroundColor: "#0b931f",
        tension: 0.2,
        borderWidth: 2,
      },
    ],
  };

  let classFilterLineDataTotal =
    filterClassPublishedData +
    filterClassDraftData +
    filterClassDistributedData;

  let classLineDataTotal =
    classPublishedData + classDraftData + classDistributedData;

  useEffect(() => {
    const trainingOptions = trainingTypes?.map((d) => ({
      label: d.Name,
      value: d.TypeId,
    }));
    const assignedOptions = assignedClass?.map((d) => ({
      label: d.Name,
      value: d.Id,
    }));
    setTrainingTypesOptions(trainingOptions);
    setAssignedClassOptions(assignedOptions);
  }, [trainingTypes, assignedClass]);

  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [fromDateValue, setFromDateValue] = useState("");
  const [toDateValue, setToDateValue] = useState("");
  const onFromDateChange = (date) => {
    setFromDateValue(date.target.value);
    setFromDate(new Date(date.target.value).toLocaleDateString());
  };

  const onToDateChange = (date) => {
    setToDateValue(date.target.value);
    const newDate = moment(date.target.value).format("DD/MM/YYYY");
    setToDate(newDate);
  };

  let date = moment(fromDate).format("DD/MM/YYYY") + "-" + toDate;
  const onFilterSearch = () => {
    debugger;
    if (selectedClass.length > 0 && selectedClass.length < 6 && selectedTraining.length < 16) {
      setSearchClicked(true);
    } else if (selectedClass.length > 5) {
      dispatch(setErrorAction("WARN", "You Can Selet Max 5 Class"));
    } else if (selectedTraining.length > 15) {
      dispatch(setErrorAction("WARN", "You Can Selet Max 15 Training Types"));
    } else {
      dispatch(setErrorAction("WARN", "Select at least one class"));
    }
    if (fromDate && toDate) {
      dispatch(
        getFilterClassDistributionSummaryActionHandler(
          selectedClassName,
          selectedTrainingType,
          date
        )
      );
      dispatch(
        getFilterClassVisualReportActionHandler(
          selectedClassName,
          selectedTrainingType,
          date
        )
      );
    } else {
      dispatch(
        getFilterClassVisualReportActionHandler(
          selectedClassName,
          selectedTrainingType
        )
      );
      dispatch(
        getFilterClassDistributionSummaryActionHandler(
          selectedClassName,
          selectedTrainingType
        )
      );
    }
  };

  useEffect(() => {
    dispatch(getClassDistributionSummaryActionHandler());
    dispatch(getClassVisualReportActionHandler());
    dispatch(getTrainingTypesActionHandler());
    dispatch(getAssignedClassActionHandler());
  }, [dispatch]);

  const handleReset = () => {
    setSelctedTraining([]);
    setSelectedClass([]);
    reset();
    setUpdatedUserGroups(assignedClass);
    setUpdatedTrainingList(trainingTypes);
    setFromDateValue("");
    setToDateValue("");
    setFromDate(moment().format("dd-mm-yyyy"));
    setFromDate(null)
    setSearchClicked(false);
  };

  let totalClassData =
    filterClassTotal +
    classFilterLineDataTotal?.length +
    filterClassMostRatedData?.length +
    filterClassMostPassedData?.length +
    filterClassMostCreditData?.length;

  //Mukesh Training Type

  const methods = useForm({
    mode: "onChange",
    resolver: yupResolver(graphicalReportSchema),
  });
  const {
    formState: { errors },
    reset,
  } = methods;

  const [userGroupList, setUserGroupList] = useState([]);
  let setUpdatedUserGroups = useCallback(
    (assignedClass) => {
      if (assignedClass?.length > 0) {
        let updatedUserGroup = assignedClass.map((userGroup) => {
          return { ...userGroup, isVisible: true };
        });
        setUserGroupList(updatedUserGroup);
      }
    },
    [assignedClass, userGroupList]
  );
  useEffect(() => {
    setUpdatedUserGroups(assignedClass);
  }, [dispatch, assignedClass]);

  useEffect(() => {
    if (userGroupList.length > 0) {
      const filtered = userGroupList.filter((item) => {
        return item.checked === true;
      });
      let updateFilteredResult = filtered.map((item) => {
        return { label: item.Name, value: item.Id };
      });
      setSelectedClass(updateFilteredResult);
    }
  }, [userGroupList, setSelectedClass]);

  const [trainingTypesList, setTrainingTypesList] = useState([]);
  let setUpdatedTrainingList = useCallback(
    (trainingTypes) => {
      if (trainingTypes?.length > 0) {
        let updatedUserGroup = trainingTypes.map((userGroup) => {
          return { ...userGroup, isVisible: true };
        });
        setTrainingTypesList(updatedUserGroup);
      }
    },
    [trainingTypes, setTrainingTypesList]
  );
  useEffect(() => {
    setUpdatedTrainingList(trainingTypes);
  }, [dispatch, trainingTypes]);

  useEffect(() => {
    if (trainingTypesList.length > 0) {
      const filtered = trainingTypesList.filter((item) => {
        return item.checked === true;
      });
      let updateFilteredResult = filtered.map((item) => {
        return { labe: item.Name, value: item.TypeId };
      });
      setSelctedTraining(updateFilteredResult);
    }
  }, [trainingTypesList, setSelctedTraining]);
  return (
    <>
      <div className={classes.reportFilter_Main}>
        <div className={classes.reportFilter_userCLass}>
          {/* <Dropdown
            isMulti
            isRequired
            label={<FormattedMessage id="REPORT_CLASSNAME_TXT" />}
            defaultValue={selectedClass}
            placeholder={intl.formatMessage({
              id: `SELECT_CLASSES`,
            })}
            options={assignedClassOptions}
            isLimit
            maxSelected={5}
            validationLabel="Classes"
            onChange={onAssignedClassSelected}
            selectedValue={selectedClass}
          /> */}
          <FormProvider {...methods}>
            <InputHookForm
              label={<FormattedMessage id="REPORT_CLASSNAME_TXT" />}
              name="ClassName"
              // labelColor="light"
              type="noSearchTags"
              fieldName={"Name"}
              fieldValue="Id"
              // placeholder={intl.formatMessage({
              //   id: `SELECT_CLASSES`,
              // })}
              placeholder={"Search Class"}
              labelMsg="(Max: 5 Classes)"
              height="3.9"
              width="24.5"
              required
              labelColor={"#404040"}
              searchable={true}
              id={"Id"}
              searchTagsList={userGroupList}
              handleTagList={(tagsList) => {
                setUserGroupList(tagsList);
              }}
              error={errors?.ClassName?.message}
            />
            <Input
              label={"From Date"}
              type={"date"}
              isFromDate
              value={fromDateValue}
              onChange={onFromDateChange}
            />
            <Input
              label={"To Date"}
              type={"date"}
              min={fromDate}
              value={toDateValue}
              onChange={onToDateChange}
            />

            <InputHookForm
              label={<FormattedMessage id="TRAINING_TYPE_TEXT" />}
              name="TrainingTypes"
              type="noSearchTags"
              fieldName={"Name"}
              fieldValue="TypeId"
              placeholder="Search Training Types"
              labelMsg="(Max: 15 Training Types)"
              height="3.9"
              width="24.5"
              labelColor={"#404040"}
              searchable={true}
              id={"TypeId"}
              searchTagsList={trainingTypesList}
              handleTagList={(tagsList) => {
                setTrainingTypesList(tagsList);
              }}
              error={errors?.TrainingTypes?.message}
            />
          </FormProvider>
          {/* <Dropdown
            label={<FormattedMessage id="Training_Types" />}
            isMulti
            isLimit
            maxSelected={15}
            validationLabel="Trainings"
            defaultValue={selectedTraining}
            placeholder={intl.formatMessage({
              id: `Training_Types`,
            })}
            options={trainingTypesOptions}
            onChange={onTrainingSelected}
            selectedValue={selectedTraining}
          /> */}
        </div>
        <div className={classes.searchResetButton}>
          <span
            style={{
              textDecoration: "underline",
              color: "#0051BC",
              cursor: "pointer",
              paddingTop: "12px",
            }}
            onClick={handleReset}
          >
            <FormattedMessage id="ANALYTICAL_REPORT_RESET" />
          </span>
          <Button
            label={<FormattedMessage id="P_Search" />}
            dark
            small
            className={classes.searchButton}
            onClick={onFilterSearch}
          />
        </div>
      </div>
      {searchClicked ? (
        <div className={classes.graphicalReport_mainLayout}>
          <div className={classes.graphicalReport_doughnut_main}>
            <div className={classes.graphicalReport_doughnut}>
              <ReportGraph
                type={"doughnut"}
                heading={<FormattedMessage id="VisualReport_User" />}
                graphData={filterClassDistributionDoughnutData}
                totalPercentage={filterClassTotal}
              />
            </div>
            <div className={classes.graphicalReport_line}>
              <ReportGraph
                yAxesText={" Count"}
                xAxesText={"Published Date (dd-MMM-yy)"}
                type={"lineGraph"}
                totalPercentage={classFilterLineDataTotal?.length}
                heading={"Status"}
                graphData={filterClassLineData}
              />
            </div>
          </div>
          <div className={classes.graphicalReport_bar_main}>
            <div className={classes.graphicalReport_bar}>
              <ReportGraph
                type={"verticalBar"}
                totalPercentage={filterClassMostRatedData?.length}
                heading={"Top 10 Most Rated"}
                graphData={filterClassRatedBarData}
                xAxesText={"Class Name"}
                yAxesText={"Rated Count"}
              />
            </div>
            <div className={classes.graphicalReport_bar}>
              <ReportGraph
                type={"verticalBar"}
                totalPercentage={filterClassMostPassedData?.length}
                heading={"Top 10 Most Passed"}
                graphData={filterClassPassedBarData}
                xAxesText={"Class Name"}
                yAxesText={"Passed Count"}
              />
            </div>
          </div>
          {/* <div className={classes.graphicalReport_bar_main}>
            <div className={classes.graphicalReport_bar}>
              <ReportGraph
                type={"verticalBar"}
                totalPercentage={filterClassMostCreditData?.length}
                heading={"Top 10 Most Credit"}
                graphData={filterClassCreditBarData}
                xAxesText={"LoginId"}
                yAxesText={"Credit Count"}
              />
            </div>
          </div> */}
        </div>
      ) : (
        <div className={classes.graphicalReport_mainLayout}>
          <div className={classes.graphicalReport_doughnut_main}>
            <div className={classes.graphicalReport_doughnut}>
              <ReportGraph
                type={"doughnut"}
                heading={<FormattedMessage id="VisualReport_User" />}
                graphData={classDistributionDoughnutData}
                totalPercentage={classTotal}
              />
            </div>

            <div className={classes.graphicalReport_line}>
              <ReportGraph
                type={"lineGraph"}
                totalPercentage={classLineDataTotal?.length}
                heading={<FormattedMessage id="REPORT_STATUS_TXT" />}
                yAxesText={"Count"}
                xAxesText={"Published Date (dd-MMM-yy)"}
                graphData={classLineData}
              />
            </div>
          </div>
          <div className={classes.graphicalReport_bar_main}>
            <div className={classes.graphicalReport_bar}>
              <ReportGraph
                totalPercentage={classMostRatedData?.length}
                type={"verticalBar"}
                heading={"Top 10 Most Rated"}
                graphData={classRatedBarData}
                xAxesText={"Class Name"}
                yAxesText={"Rated Count"}
              />
            </div>
            <div className={classes.graphicalReport_bar}>
              <ReportGraph
                totalPercentage={classMostPassedData?.length}
                type={"verticalBar"}
                heading={"Top 10 Most Passed"}
                graphData={classPassBarData}
                xAxesText={"Class Name"}
                yAxesText={"Passed Count"}
              />
            </div>
          </div>
          {/* <div className={classes.graphicalReport_bar_main}>
            <div className={classes.graphicalReport_bar}>
              <ReportGraph
                type={"verticalBar"}
                totalPercentage={classMostCreditData?.length}
                heading={"Top 10 Most Credit"}
                graphData={classCreditBarData}
                xAxesText={"LoginId"}
                yAxesText={"Credit Count"}
              />
            </div>
          </div> */}
        </div>
      )}
    </>
  );
};

export default injectIntl(ClassGraphicalReport);
